// extracted by mini-css-extract-plugin
export default {"projectPanel":"projectPanel__euae7z","tableHeadings":"tableHeadings__trh1jr","aboutProject":"aboutProject__e5ZwuQ","notesHeadings":"notesHeadings__kCMwVH","label":"label__LPmjHP"};